import $fetch from '@/services/client'
import type { SendToDealerBodyType } from '@/services/schemas'

async function sendToDealer(body: SendToDealerBodyType) {
  const response = await $fetch('mycontroller/send-configuration/to/dealer/json', {
    body,
  })

  if (response.error) throw new Error(response.error.statusText + response.error.message)

  return response.data
}

export default sendToDealer
